<template>
  <div
    v-if="surveyData._id"
    v-analytics.pageview="'welcome'"
    class="page page-welcome"
  >
    <b-notification
      v-if="$previewCode"
      type="is-warning"
      aria-close-label="Close notification"
      role="alert"
      class="preview-alert"
    >
      当前为预览页面，答案不被记录
    </b-notification>
    <div class="welcome">
      <div class="welcome-title">
        <rich-text :html="surveyData.title" />
      </div>
      <div class="welcome-content">
        <rich-text :html="surveyData.introduction" />
      </div>
      <div class="welcome-action">
        <!--<p class="action-protocol">本问卷遵循和适用<a href="">《腾讯服务协议》</a>及<a href="">《腾讯隐私政策》</a>。</p>-->
        <!--<label class="action-signature">-->
        <!--<b-checkbox v-model="signature">-->
        <!--<span>已阅读并同意以上规则</span>-->
        <!--</b-checkbox>-->
        <!--</label>-->
        <b-button
          v-analytics.click="{
            action: 'welcome',
            category: 'click',
          }"
          type="is-primary"
          class="welcome-btn"
          @click="start"
        >
          {{ $t('start') }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getUserFeatures, hasUserFeatures } from './answer/answer-utils';
import answerMixin from './answer/answer-mixin';

export default {
  name: 'Welcome',

  mixins: [answerMixin],

  data() {
    return {
      signature: false,
    };
  },

  computed: {
    ...mapState(['surveyData', 'configs']),
  },

  watch: {
    configs: {
      handler(val) {
        // 海外验证流程增加数据校验，功能开启时，当答题者answer页检查国家/地区、年龄数据是否有值；若为空，跳转到海外流程页面
        this.userFeatures = getUserFeatures();
        if (val.verification && !hasUserFeatures(this.userFeatures)) {
          this.routeReplace('verification', this.$route.query, this.getSurveyLang(this.surveyData));
        }
      },
      immediate: true,
    },
  },

  methods: {
    start() {
      const { query } = this.$route;
      this.$router.replace({ name: 'answer', query });
    },
  },
};
</script>

<style lang="scss">
  $checkboxSize: 30px / $px;
  $desktopCheckboxSize: 14px;
  .page-welcome{
    min-height: 100vh;
  }
  .welcome {
    padding: $padding $padding 138px / $px;
    @include desktop {
      width: $desktopWidth;
      padding: 0;
      margin: 0 auto;
    }
    @include landscape {
      padding: $landscape-title-padding $landscapePadding 138px / $px $landscapePadding;
      margin: 0 auto;
    }
    &-title {
      text-align: center;
      font-weight: 600;
      color: #1A1A1A;
      margin-bottom: $gap-lg;
      .ql-container {
        line-height: $titleLineHeight;
        font-size: $title-font-size;
        @include desktop {
          font-weight: normal;
          color: $black;
          padding: $desktop-title-padding 0;
        }
        @include landscape {
          font-weight: normal;
          color: $black;
        }
      }
    }
    &-content {
      color: #444;
      .ql-container {
        line-height: 34px / $px;
        font-size: $descSize;
      }
      p {
        margin-bottom: $gap-sm;
      }
    }
    &-action {
      .action-protocol {
        font-size: $descSize;
        margin-bottom: 20px / $px;
        @include desktop {
          font-size: 16px;
        }
        @include landscape {
          font-size: 16px;
        }
      }
      .action-signature {
        display: block;
        line-height: $descLineHeight;
        .checkbox {
          line-height: $descLineHeight;
          @include desktop {
            line-height: $desktopDescLineHeight;
          }
          @include landscape {
            line-height: $desktopDescLineHeight;
          }
        }
        @include desktop {
          line-height: $desktopDescLineHeight;
        }
        @include landscape {
          line-height: $desktopDescLineHeight;
        }
      }
      .b-checkbox.checkbox input[type=checkbox] + .check {
        width: $checkboxSize;
        height: $checkboxSize;
        @include desktop {
          width: $desktopCheckboxSize;
          height: $desktopCheckboxSize;
        }
        @include landscape {
          width: $desktopCheckboxSize;
          height: $desktopCheckboxSize;
        }
      }
      .control-label {
        font-size: $descSize;
        @include desktop {
          font-size: 16px;
        }
        @include landscape {
          font-size: 16px;
        }
      }
      a {
        color: $a;
      }
    }
    &-btn {
      min-width: 100%;
      margin-top: 60px / $px;
      @include desktop {
        min-width: 220px;
        margin: 60px auto 0;
      }
      @include landscape {
        min-width: 340px;
        margin: 30px auto 0;
      }
    }
  }
  .b-checkbox.checkbox .check {
    margin-top: ($descLineHeight - $checkboxSize) / 2;
    @include desktop {
      margin-top: ($desktopDescLineHeight - $desktopCheckboxSize) / 2;
    }
    @include landscape {
      margin-top: ($desktopDescLineHeight - $desktopCheckboxSize) / 2;
    }
  }
  .preview-alert {
    border-radius: 0 !important;
    margin-bottom: 0 !important;
  }
</style>
